/**
 * @generated SignedSource<<6428018ff894ea45b40e54638e0c88b1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpHistory_nftItem$data = {
  readonly etherRates: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"useEtherConversion_etherRates">;
  } | null> | null;
  readonly serviceId: string | null;
  readonly tokenId: string | null;
  readonly " $fragmentType": "NftPdpHistory_nftItem";
};
export type NftPdpHistory_nftItem$key = {
  readonly " $data"?: NftPdpHistory_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistory_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpHistory_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "etherRates",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useEtherConversion_etherRates"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "a1be7cdcdb80336928166c7be91ed329";

export default node;
